
import { Industry, OrganizationDetails, OrganizationSize } from "@/types/assessment";
import { ExecutiveSummary } from "./sections/ExecutiveSummary";
import { DimensionAnalysis } from "./sections/DimensionAnalysis";
import { BenchmarkSection } from "./sections/BenchmarkSection";
import { StrategicRoadmap } from "./sections/StrategicRoadmap";
import { AIMAAInsights } from "./sections/AIMAAInsights";
import { RealTimeAnalytics } from "./sections/RealTimeAnalytics";

interface ResultsContentProps {
  overallScore: number;
  description: string;
  dimensionScores: Record<string, number>;
  maturityLevel: string;
  industry: Industry;
  organizationSize: OrganizationSize;
  assessmentId: string;
  organizationDetails: OrganizationDetails;
}

export const ResultsContent = ({ 
  overallScore, 
  description, 
  dimensionScores,
  maturityLevel,
  industry,
  organizationSize,
  assessmentId,
  organizationDetails
}: ResultsContentProps) => {
  const lowestScore = Math.min(...Object.values(dimensionScores));
  const lowestDimension = Object.entries(dimensionScores).find(([_, score]) => score === lowestScore)?.[0] || '';

  return (
    <div className="space-y-8">
      <ExecutiveSummary 
        organizationName={organizationDetails.name}
        overallScore={overallScore}
        maturityLevel={maturityLevel}
        description={description}
        industry={industry}
        lowestDimension={lowestDimension}
        lowestScore={lowestScore}
      />

      <DimensionAnalysis 
        dimensionScores={dimensionScores}
        industry={industry}
      />

      <BenchmarkSection 
        dimensionScores={dimensionScores}
        industry={industry}
        organizationDetails={organizationDetails}
      />

      {/* Real-time analytics section */}
      <RealTimeAnalytics
        dimensionScores={dimensionScores}
        overallScore={overallScore}
        industry={industry}
        organizationName={organizationDetails.name}
      />

      {/* AIMAA Insights section - moved to follow Real-Time Analytics */}
      <AIMAAInsights 
        assessmentId={assessmentId}
        assessmentData={{
          organizationDetails: {
            industry,
            size: organizationSize
          },
          dimensionScores
        }}
      />

      {/* Strategic Roadmap section - moved to the end */}
      <StrategicRoadmap 
        maturityLevel={maturityLevel}
        dimensionScores={dimensionScores}
        lowestDimension={lowestDimension}
      />
    </div>
  );
};
